/* DESIGN-40B behaviour layer (loaded last, deferred). Rollback: remove its script tag from layout/theme.liquid. */
(function () {
  'use strict';
  var touch = window.matchMedia && matchMedia('(hover: none)').matches;

  /* Touch: product cards keep the model (image 1). The scroll "peek" flipped whichever row sat mid-screen
     to its flat lay, so a two-up grid always showed a row of flats. Desktop hover is untouched. */
  if (touch && window.customElements) {
    customElements.whenDefined('product-card').then(function () {
      var P = customElements.get('product-card');
      if (P && P.prototype && typeof P.prototype.previewImage === 'function') P.prototype.previewImage = function () {};
    });
  }

  /* Escape closes the menu drawer, including from a submenu. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('details#Details-menu-drawer-container[open]');
    if (!d) return;
    var s = d.querySelector('summary');
    if (s) s.click(); else d.removeAttribute('open');
  });

  /* The house name reads once, in the logo: drop the "Marcel Afters " prefix from product names shown in
     search results, the quick-shop sheet and the bag (display only; product titles are unchanged). */
  var SEL = '.predictive-search-results__card .product-card__title, .predictive-search-results a p, predictive-search-component [class*="title"], .ma-qs-sheet__title, .ma-qs__head, .cart-items__title, .cart-item__title, .cart-items a[href*="/products/"]';
  var RX = /^\s*Marcel Afters\s+/;
  function clean(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.children.length) {
        el.childNodes.forEach(function (n) { if (n.nodeType === 3 && RX.test(n.textContent)) n.textContent = n.textContent.replace(RX, ''); });
      } else if (RX.test(el.textContent)) el.textContent = el.textContent.replace(RX, '');
    });
  }
  /* Perf (4 Oct 2026): this used to run clean() (7 selector sweeps of the whole document) on the next animation frame after
     EVERY DOM mutation, i.e. every frame during load while cards, images and scripts were inserting nodes (240-625 ms of
     script time per page load). The strings it fixes only appear in search results, the quick-shop sheet and the bag,
     so at most one sweep per 100 ms (first mutation arms it, so a long mutation burst cannot starve it) is enough. */
  var t = 0;
  new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = 0; clean(); }, 100); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { clean(); }); else clean();
})();
